import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import StyledHero from '../components/StyledHero';
import BlogList from '../components/Blog/BlogList';
import SEO from '../components/SEO';
const blog = ({ data }) => {
  return (
    <Layout>
      <SEO title="Blog" description="this is blog description"></SEO>
      <StyledHero img={data.blogBcg.childImageSharp.fluid}></StyledHero>
      <BlogList></BlogList>
    </Layout>
  );
};

export const query = graphql`
  query {
    blogBcg: file(relativePath: { eq: "blogBcg.jpeg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default blog;
